import React, { useState, useRef, useEffect } from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import MultiRangeSlider from "../multirangeslider/MultiRangeSlider";
import PropertyTypesOptions from "./filters-tabs/property-types";
import SizeFiltersTab from "./filters-tabs/size";
import RecommendedFiltersTab from "./filters-tabs/recommended";
import LabelsOptions from "./filters-tabs/labels";
import BuildingLotMoreFilters from "./filters-tabs/building_lot";
import OwnerMoreFilters from "./filters-tabs/owner";
import SalesMoreFilters from "./filters-tabs/sales";
import DebtMoreFilters from "./filters-tabs/debt";
import TaxMoreFilters from "./filters-tabs/tax";
import TabsHeader from "./filters-tabs/tabs-header";
import FilterSubmitButton from "./filters-tabs/filter-submit-button";
import { useForm } from "react-hook-form";
import { useNavigate, useLocation } from "react-router-dom";
import * as helpers from "../../../helpers/helpers";
import http from "../../../helpers/http";
import httpos from "../../../helpers/httpos";

export default function NewFiltersForm({
  setSearchResultsData,
  setTotalPropertiesRecords,
  setIsLoadingform,
  setShowSearchResults,
  renderMap,
  ownertoggle,
  hideSearch,
  ToggleHideSearch,
  showMap,
  drawnFeatures,
  setDrawnFeatures,
}) {
  const location = useLocation();
  const { pathname } = location;
  const segments = pathname.split("/");
  const [propertyCatsCounts, setPropertyCatsCounts] = useState({});
  useEffect(() => {
    http
      .post("getFilterCounts", "")
      .then(({ data }) => {
        setPropertyCatsCounts(data?.counts);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  const [userLabels, setUserLabels] = useState([]);
  const fetchUserLabels = () => {
    httpos
      .post("get-user-label-properties", "")
      .then(({ data }) => {
        setUserLabels(data.labels);
      })
      .catch((error) => {});
  };
  useEffect(() => {
    fetchUserLabels();
  }, []);
  const navigate = useNavigate();

  const {
    register,
    setValue,
    watch,
    reset,
    handleSubmit,
    control,
    getValues,
    trigger,
    formState: { errors, isValid },
  } = useForm();
  const filterData = watch();
  const [isLoading, setIsLoading] = useState(false);
  const queryParams = new URLSearchParams(location.search);
  const hasSearchedRef = useRef(false);
  useEffect(() => {
    if (
      segments[1] !== "owner-property" &&
      segments[1] !== "owner-overview" &&
      segments[1] !== "property-details"
    ) {
      if (hasSearchedRef.current) return;
      hasSearchedRef.current = true;
      const allParams = {};
      for (const [key, value] of queryParams.entries()) {
        allParams[key] = value;
      }
      const searchParams = new URLSearchParams(location.search);
      const propertyTypeParam =
        searchParams.get("property_type")?.split(",") || [];
      const min_unites = searchParams.get("min_unites") || "";
      const search_query = allParams?.search_query;
      if (search_query) {
        setValue("search_query", search_query);
      }
      const search_type = allParams?.search_type;
      if (search_type) {
        setValue("search_type", search_type);
      }
      const max_unites = searchParams.get("max_unites") || "";
      if (max_unites) {
        setValue("max_unites", max_unites);
      }
      if (min_unites) {
        setValue("min_unites", min_unites);
      }
      const min_sf = searchParams.get("min_sf") || "";
      const max_sf = searchParams.get("max_sf") || "";
      if (max_sf) {
        setValue("max_sf", max_sf);
      }
      if (min_sf) {
        setValue("min_sf", min_sf);
      }
      const min_lotsize = searchParams.get("min_lotsize") || "";
      const max_lotsize = searchParams.get("max_lotsize") || "";
      if (max_lotsize) {
        setValue("max_lotsize", max_lotsize);
        setValue("size_max_lotsize", max_lotsize);
        setValue("building_max_lotsize", max_lotsize);
      }
      if (min_lotsize) {
        setValue("min_lotsize", min_lotsize);
        setValue("size_min_lotsize", min_lotsize);
        setValue("building_min_lotsize", min_lotsize);
      }
      const year_build = searchParams.get("year_build") || "";
      const year_build_until = searchParams.get("year_build_until") || "";
      if (year_build) {
        setValue("year_build", year_build);
        setValue("building_lot_year_build", year_build);
        setValue("recommend_year_build", year_build);
      }
      if (year_build_until) {
        setValue("year_build_until", year_build_until);
        setValue("recommend_year_build_until", year_build_until);
        setValue("building_lot_year_build_until", year_build_until);
      }
      const properties_in_portfolio_min =
        searchParams.get("properties_in_portfolio_min") || "";
      const properties_in_portfolio_max =
        searchParams.get("properties_in_portfolio_max") || "";
      if (properties_in_portfolio_min) {
        setValue("properties_in_portfolio_min", properties_in_portfolio_min);
        setValue(
          "owner_properties_in_portfolio_min",
          properties_in_portfolio_min
        );
        setValue(
          "recommend_properties_in_portfolio_min",
          properties_in_portfolio_min
        );
      }
      if (properties_in_portfolio_max) {
        setValue("properties_in_portfolio_max", properties_in_portfolio_max);
        setValue(
          "owner_properties_in_portfolio_max",
          properties_in_portfolio_max
        );
        setValue(
          "recommend_properties_in_portfolio_max",
          properties_in_portfolio_max
        );
      }
      const recommended_owner_property_sq_ft =
        searchParams.get("recommended_owner_property_sq_ft") || "";
      if (recommended_owner_property_sq_ft) {
        setValue(
          "recommended_owner_property_sq_ft",
          recommended_owner_property_sq_ft
        );
      }
      const recommended_owner_portfolio =
        searchParams.get("recommended_owner_portfolio") || "";
      if (recommended_owner_portfolio) {
        setValue("recommended_owner_portfolio", recommended_owner_portfolio);
      }
      const zonedcodelocal = searchParams.get("zonedcodelocal") || "";
      if (zonedcodelocal) {
        setValue("zonedcodelocal", zonedcodelocal);
      }
      const owner_name = searchParams.get("owner_name") || "";
      if (owner_name) {
        setValue("owner_name", owner_name);
      }
      const reported_owner = searchParams.get("reported_owner") || "";
      if (reported_owner) {
        setValue("reported_owner", reported_owner);
      }
      const reported_owner_address =
        searchParams.get("reported_owner_address") || "";
      if (reported_owner_address) {
        setValue("reported_owner_address", reported_owner_address);
      }
      const owner_type = searchParams.get("owner_type") || "";
      if (owner_type) {
        setValue("owner_type", owner_type);
      }
      const previously_viewed = searchParams.get("previously_viewed") || "";
      if (previously_viewed) {
        setValue("previously_viewed", previously_viewed);
      }
      const sale_date = searchParams.get("sale_date") || "";
      if (sale_date) {
        setValue("sale_date", sale_date);
      }
      const min_sales_price = searchParams.get("min_sales_price") || "";
      if (min_sales_price) {
        setValue("min_sales_price", min_sales_price);
      }
      const max_sales_price = searchParams.get("max_sales_price") || "";
      if (max_sales_price) {
        setValue("max_sales_price", max_sales_price);
      }
      const min_sales_price_sf = searchParams.get("min_sales_price_sf") || "";
      if (min_sales_price_sf) {
        setValue("min_sales_price_sf", min_sales_price_sf);
      }
      const max_sales_price_sf = searchParams.get("max_sales_price_sf") || "";
      if (max_sales_price_sf) {
        setValue("max_sales_price_sf", max_sales_price_sf);
      }
      const min_sales_price_acr = searchParams.get("min_sales_price_acr") || "";
      if (min_sales_price_acr) {
        setValue("min_sales_price_acr", min_sales_price_acr);
      }
      const max_sales_price_acr = searchParams.get("max_sales_price_acr") || "";
      if (max_sales_price_acr) {
        setValue("max_sales_price_acr", max_sales_price_acr);
      }
      const mortage_origination = searchParams.get("mortage_origination") || "";
      if (mortage_origination) {
        setValue("mortage_origination", mortage_origination);
      }
      const min_tax_amount = searchParams.get("min_tax_amount") || "";
      if (min_tax_amount) {
        setValue("min_tax_amount", min_tax_amount);
      }
      const max_tax_amount = searchParams.get("max_tax_amount") || "";
      if (max_tax_amount) {
        setValue("max_tax_amount", max_tax_amount);
      }
      const tax_min_year = searchParams.get("tax_min_year") || "";
      if (tax_min_year) {
        setValue("tax_min_year", tax_min_year);
      }
      const tax_max_year = searchParams.get("tax_max_year") || "";
      if (tax_max_year) {
        setValue("tax_max_year", tax_max_year);
      }
      const notes_text = searchParams.get("notes_text") || "";
      if (notes_text) {
        setValue("notes_text", notes_text);
      }
      const note = searchParams.get("note") || "";
      if (note) {
        setValue("note", note);
      }
      const viewed_date = searchParams.get("viewed_date") || "";
      if (viewed_date) {
        setValue("viewed_date", viewed_date);
      }
      const occupaid = searchParams.get("occupaid") || "";
      if (occupaid) {
        setValue("occupaid", occupaid);
        setValue("owner_occupaid", occupaid);
        setValue("recommend_occupaid", occupaid);
      }
      if (propertyTypeParam.length) {
        setValue("property_type", propertyTypeParam);
        setValue("polular_property_type", propertyTypeParam);
        setValue("more_property_type", propertyTypeParam);
      }
      if (Object.keys(allParams).length > 0) {
        const searchFormData = { ...allParams, page: 1 };
        if (!isLoading) {
          setIsLoading(true);
          console.log("Called", searchFormData);
          searchApiRequest(searchFormData, true);
        }
      }
    }
  }, []);
  const getUrlParameter = (name) => {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
    var results = regex.exec(window.location.search);
    return results === null
      ? ""
      : decodeURIComponent(results[1].replace(/\+/g, " "));
  };
  useEffect(() => {
    if (
      drawnFeatures &&
      localStorage.getItem("drawnFeatures") !== drawnFeatures
    ) {
      const geometry_polygon = getUrlParameter("geometry");
      let geometry = drawnFeatures || geometry_polygon || null;
      const searchFormData = { ...filterData, page: 1, geometry: geometry };
      const queryString = Object.entries(searchFormData)
        .filter(([key, value]) => {
          // Remove if value is null, undefined, false, empty string
          return !(
            value === null ||
            value === undefined ||
            value === false ||
            value === "" ||
            value === "null" ||
            value === "false" ||
            value === "undefined"
          );
        })
        .map(
          ([key, value]) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
        )
        .join("&");

      navigate(
        {
          pathname: location.pathname,
          search: `?${queryString}`,
        },
        { replace: true }
      );
      searchApiRequest(searchFormData, true);
    }
  }, [drawnFeatures]);

  const searchApiEndPoint = () => {
    // Filter out keys with falsy values from filterData
    const filteredData = Object.fromEntries(
      Object.entries(filterData).filter(([key, value]) => {
        return (
          value !== null &&
          value !== undefined &&
          value !== false &&
          value !== "" &&
          value !== "null" &&
          value !== "undefined"
        );
      })
    );

    const searchFormData = { ...filteredData, page: 1 };
    searchApiRequest(searchFormData);
  };
  const searchApiRequest = (searchFormData, onLoad = false) => {
    if (!searchFormData?.geometry) {
      const geometry_polygon = getUrlParameter("geometry");
      let geometry = drawnFeatures || geometry_polygon || null;
      searchFormData = { ...searchFormData, geometry: geometry };
    }
    console.count("searchApiRequest called");
    // console.log("called again");
    if (!onLoad) setIsLoadingform(true);
    httpos
      .post("/search-data", helpers.doObjToFormData(searchFormData))
      .then(({ data }) => {
        
        console.log(data);
        renderMap(data.parcel_ids, searchFormData);
        const properties_list = JSON.stringify(data);
        localStorage.setItem("listingData", properties_list);
        localStorage.setItem("currentFilters", JSON.stringify(searchFormData));
        setSearchResultsData([]);
        setSearchResultsData(JSON.stringify(data));
        setTotalPropertiesRecords(Number(data.totalRecords));

        setShowSearchResults(true);
        ownertoggle(true);
        setIsLoadingform(false);
      })
      .catch((error) => {
        setIsLoadingform(false);
        console.log(error);
      });
  };

  const onSubmit = (frmData) => {
    console.log(frmData);
    const queryString = Object.entries(frmData)
      .filter(([key, value]) => {
        // Remove if value is null, undefined, false, empty string
        return !(
          value === null ||
          value === undefined ||
          value === false ||
          value === "" ||
          value === "null" ||
          value === "false" ||
          value === "undefined"
        );
      })
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");

    navigate(
      {
        pathname: location.pathname,
        search: `?${queryString}`,
      },
      { replace: true }
    );
    // Call the API with the updated filter data
    searchApiEndPoint();
  };
  const [openDropdown, setOpenDropdown] = useState(null);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const viewed_Date_options = [
    {
      value: "past_day",
      label: "Past day",
      backgroundColor: "#67773F",
      textColor: "white",
    },
    { value: "past_7_days", label: "Past 7 days" },
    { value: "30_days", label: "Past 30 days" },
    { value: "3_mnth", label: "Past 3 months" },
  ];
  const [selectedTab, setSelectedTab] = useState(0);
  useEffect(() => {
    setOpenDropdown(null);
    setSelectedTab(0);
  }, [location]);
  return (
    <div className="filter_sec_new">
      <form className="filter_new" onSubmit={handleSubmit(onSubmit)}>
        <div className="flex">
          <div className={hideSearch ? "seach_field hide" : "seach_field"}>
            <div className="search_field_inner">
              <input
                type="text"
                name="search_query"
                className="input"
                placeholder="Address,city,state,postal code"
                {...register("search_query")}
                defaultValue={filterData?.search_query}
              />
              <select
                name="search_type"
                className="input"
                {...register("search_type")}
              >
                <option
                  value="address"
                  selected={filterData?.search_type == "address" ? true : false}
                >
                  Address
                </option>
                <option
                  value="city_state"
                  selected={
                    filterData?.search_type == "city_state" ? true : false
                  }
                >
                  City, State
                </option>
                <option
                  value="zipcode"
                  selected={filterData?.search_type == "zipcode" ? true : false}
                >
                  Zipcode
                </option>
                <option
                  value="owner_name"
                  selected={
                    filterData?.search_type == "owner_name" ? true : false
                  }
                >
                  Property Owner
                </option>
              </select>
              <button type="submit">
                <img src="/images/search_green.svg" alt="" />
              </button>
            </div>
            <button
              className="hide_cell_filter"
              type="button"
              onClick={ToggleHideSearch}
            >
              <img src="/images/eye_circle_hide.svg" alt="" />
            </button>
          </div>
          <div className="r_new_filters" ref={containerRef}>
            <div className="col">
              <div
                className="filter_btn site_btn blank yellow_blank"
                onClick={() =>
                  setOpenDropdown(
                    openDropdown === "propertyType" ? null : "propertyType"
                  )
                }
              >
                Property type
              </div>
              <div
                className={
                  openDropdown === "propertyType"
                    ? "drop_cnt filter_property left_drop lg active"
                    : "drop_cnt filter_property left_drop lg"
                }
              >
                <div className="head_filter">
                  <p className="dark_text">Popular categories</p>
                </div>
                <div className="form-row row">
                  <PropertyTypesOptions
                    register={register}
                    filterData={filterData}
                    fieldNamePrefix="popular"
                    setValue={setValue}
                    watch={watch}
                    propertyCatsCounts={propertyCatsCounts}
                  />
                </div>
                <FilterSubmitButton
                  className="property_type_btn"
                  clearStep="property_type"
                  setValue={setValue}
                  filterData={filterData}
                />
              </div>
            </div>
            <SizeFiltersTab
              openDropdown={openDropdown}
              setOpenDropdown={setOpenDropdown}
              register={register}
              filterData={filterData}
              setValue={setValue}
              watch={watch}
            />
            <RecommendedFiltersTab
              openDropdown={openDropdown}
              setOpenDropdown={setOpenDropdown}
              register={register}
              filterData={filterData}
              setValue={setValue}
              watch={watch}
            />
            <div className="col">
              <div
                className="filter_btn site_btn blank yellow_blank"
                onClick={() =>
                  setOpenDropdown(
                    openDropdown === "myProperties" ? null : "myProperties"
                  )
                }
              >
                My properties
              </div>
              <div
                className={
                  openDropdown === "myProperties"
                    ? "drop_cnt active right_drop"
                    : "drop_cnt right_drop"
                }
              >
                <div className="outer_prop">
                  <div className="form_blk">
                    <h6 className="f_size_16">Exported properties</h6>
                    <div className="boolean_flex">
                      <div className="lbl_btn">
                        <input
                          type="radio"
                          name="exported_properties"
                          id="include"
                          value="include"
                          className="hidden"
                        />
                        <label
                          htmlFor="include"
                          className="site_btn blank yellow_blank main_color"
                        >
                          <span
                            style={{
                              color: "black",
                            }}
                          >
                            Include
                          </span>
                        </label>
                      </div>
                      <div className="lbl_btn">
                        <input
                          type="radio"
                          name="exported_properties"
                          id="exclude"
                          value="exclude"
                          className="hidden"
                        />
                        <label
                          htmlFor="exclude"
                          className="site_btn blank yellow_blank main_color"
                          style={{
                            backgroundColor: "#67773F",
                          }}
                        >
                          <span
                            style={{
                              color: "white",
                            }}
                          >
                            Exclude
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <LabelsOptions
                    register={register}
                    filterData={filterData}
                    userLabels={userLabels}
                    setValue={setValue}
                    watch={watch}
                  />
                  <FilterSubmitButton
                    clearStep="my_properties"
                    setValue={setValue}
                    filterData={filterData}
                  />
                </div>
              </div>
            </div>
            <div className="col mobile_filter_advance">
              <button
                type="button"
                className="site_btn yellow_blank blank"
                onClick={() =>
                  setOpenDropdown(
                    openDropdown === "moreFilters" ? null : "moreFilters"
                  )
                }
              >
                {/* <img src="/images/plus_icon_dark.svg" alt="" /> */}
                <img
                  src="/images/ad_filter.svg"
                  alt=""
                  className="show_cell_advance_icon"
                />
                <span>More filters</span>
              </button>
              <div
                className={
                  openDropdown === "moreFilters"
                    ? "drop_cnt active wide_drop"
                    : "drop_cnt wide_drop"
                }
              >
                <div className="more_filter_drop tabs_filter">
                  <div className="sub_filter">
                    <div className="tabs_main">
                      <div className="react-tabs">
                        <ul className="react-tabs__tab-list" role="tablist">
                          <TabsHeader
                            selectedTab={selectedTab}
                            setSelectedTab={setSelectedTab}
                          />
                        </ul>
                      </div>
                      <div
                        style={{
                          display: selectedTab === 0 ? "block" : "none",
                        }}
                      >
                        <div class="react-tabs__tab-panel react-tabs__tab-panel--selected">
                          <div className="check_flex flex">
                            <div className="col">
                              <div className="form-row row">
                                <PropertyTypesOptions
                                  register={register}
                                  filterData={filterData}
                                  fieldNamePrefix="more"
                                  setValue={setValue}
                                  watch={watch}
                                  propertyCatsCounts={propertyCatsCounts}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          display: selectedTab === 1 ? "block" : "none",
                        }}
                      >
                        <div class="react-tabs__tab-panel react-tabs__tab-panel--selected">
                          <div className="half_flex_outer mix_half_flex flex">
                            <BuildingLotMoreFilters
                              register={register}
                              filterData={filterData}
                              setValue={setValue}
                              watch={watch}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          display: selectedTab === 2 ? "block" : "none",
                        }}
                      >
                        <div class="react-tabs__tab-panel react-tabs__tab-panel--selected">
                          <div className="half_flex_outer mix_half_flex flex owner_flex">
                            <OwnerMoreFilters
                              register={register}
                              setValue={setValue}
                              filterData={filterData}
                              watch={watch}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          display: selectedTab === 3 ? "block" : "none",
                        }}
                      >
                        <div class="react-tabs__tab-panel react-tabs__tab-panel--selected">
                          <div className="half_flex_outer mix_half_flex flex owner_flex">
                            <SalesMoreFilters
                              register={register}
                              setValue={setValue}
                              filterData={filterData}
                            />
                          </div>
                          <div className="footer_filter_btn">
                            <div className="text_left">
                              <p>Filters apply to most recent transaction</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          display: selectedTab === 4 ? "block" : "none",
                        }}
                      >
                        <div class="react-tabs__tab-panel react-tabs__tab-panel--selected">
                          <div className="mix_half_flex flex owner_flex">
                            <DebtMoreFilters
                              register={register}
                              setValue={setValue}
                              filterData={filterData}
                            />
                          </div>
                          <div className="footer_filter_btn">
                            <div className="text_left">
                              <p>Filters apply to most recent transaction</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          display: selectedTab === 5 ? "block" : "none",
                        }}
                      >
                        <div class="react-tabs__tab-panel react-tabs__tab-panel--selected">
                          <div className="mix_half_flex flex owner_flex half_flex_outer">
                            <TaxMoreFilters
                              register={register}
                              setValue={setValue}
                              filterData={filterData}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        style={{
                          display: selectedTab === 6 ? "block" : "none",
                        }}
                      >
                        <div class="react-tabs__tab-panel react-tabs__tab-panel--selected">
                          <div className="mix_half_flex flex owner_flex">
                            <div className="col half_flex_form">
                              <div className="form_blk">
                                <LabelsOptions
                                  register={register}
                                  filterData={filterData}
                                  userLabels={userLabels}
                                  setValue={setValue}
                                  watch={watch}
                                />
                                <div className="br"></div>
                                <div className="form_blk">
                                  <div className="info_lbl_lbl">
                                    <h6>Viewed Date</h6>
                                  </div>
                                  <div className="boolean_flex">
                                    {viewed_Date_options.map((option) => (
                                      <div
                                        className="lbl_btn"
                                        key={option.value}
                                      >
                                        <input
                                          type="radio"
                                          name="viewed_date"
                                          value={option.value}
                                          id={option.value}
                                          className="hidden"
                                          {...register("viewed_date")}
                                        />
                                        <label
                                          htmlFor={option.value}
                                          className={`site_btn blank yellow_blank main_color ${
                                            filterData?.viewed_date ===
                                            option.value
                                              ? "active"
                                              : ""
                                          }`}
                                        >
                                          <span>{option.label}</span>
                                        </label>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                                <div className="br"></div>
                              </div>
                            </div>
                            <div className="col">
                              <div className="form_blk">
                                <div className="info_lbl_lbl">
                                  <h6>Note text</h6>
                                </div>
                                <input
                                  type="text"
                                  placeholder="Text"
                                  className="input"
                                  name="notes_text"
                                  {...register("notes_text")}
                                  filterData={filterData?.notes_text}
                                />
                              </div>
                              <div className="br"></div>
                              <div className="form_blk">
                                <div className="info_lbl_lbl">
                                  <h6>Has a note?</h6>
                                </div>
                                <div className="lbl_btn">
                                  <input
                                    type="checkbox"
                                    name="note"
                                    id="note"
                                    {...register("note")}
                                    defaultChecked={
                                      filterData?.note ? true : false
                                    }
                                  />
                                  <label htmlFor="note">Yes</label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <FilterSubmitButton
                        clearStep="more_filters"
                        setValue={setValue}
                        selectedTab={selectedTab}
                        filterData={filterData}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col">
              <button
                className="filter_btn site_btn blank yellow_blank"
                type="submit"
              >
                Search Result
              </button>
            </div>
            {!hideSearch && showMap ? (
              <div className="col hide_cell_filter">
                <button
                  className="site_btn blank no_filter"
                  onClick={ToggleHideSearch}
                  type="button"
                >
                  <span>Hide Search</span>
                  <img src="/images/eye_circle_hide.svg" alt="" />
                </button>
              </div>
            ) : (
              ""
            )}
          </div>
          {/* {!hideSearch && showMap && (
            <div className="cell_show_filters">
              <button className="site_btn" onClick={ToggleHideSearch}>
                <span>Show Search</span>
                <img src="/images/eye_circle_hide.svg" alt="" />
              </button>
            </div>
          )} */}
        </div>
      </form>
    </div>
  );
}
